
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Routing from './router/routing';

function App() {
  return (
    <BrowserRouter>
      <Routing/>
    </BrowserRouter>
  );
}

export default App;
